import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
//import { Http, Headers, RequestOptions } from '@angular/common/http';



import { Observable } from 'rxjs/observable';
import { Injectable } from '@angular/core';
import { GlobalProvider } from "../../providers/global/global";
import { HttpClient, HttpHeaders, HttpInterceptor, HttpClientModule, HttpResponse } from '@angular/common/http';
import {BaseRequestOptions, RequestOptions, Headers, RequestOptionsArgs} from "@angular/http";


import { ImagePicker } from '@ionic-native/image-picker';
import { Base64 } from '@ionic-native/base64';
import { File } from '@ionic-native/file';
import { Transfer, TransferObject } from '@ionic-native/transfer';
import { FilePath } from '@ionic-native/file-path';
import { Camera } from '@ionic-native/camera';
import { Storage } from '@ionic/storage';

import { VisitorsRegPage } from '../visitors-reg/visitors-reg';
import { VideoPage } from '../video/video';
import { ReactivatePage } from '../reactivate/reactivate';
import { HomePage } from '../home/home';
import { ForgotPage } from '../forgot/forgot';
import { SecurityhomePage } from '../securityhome/securityhome';



declare var cordova: any;

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  private login_form : FormGroup;
  
  accesscode = "";
  password = "";
  authDecrypt = "";

  
  passtype = "password";
  showPass = false;

  /*
  validation_messages = {
    'accesscode': [
      { type: 'required', message: '*Please enter your accesscode.' },
    ],
    'password': [
      { type: 'required', message: '*Please enter password.' },
    ],
      
  }*/






  constructor( 
    private formBuilder: FormBuilder,  
    public navCtrl: NavController, 
    private toastCtrl: ToastController, 
    public navParams: NavParams,     
    public http: HttpClient,    
    private imagePicker: ImagePicker,    
    private base64: Base64,
    private camera: Camera, 
    private transfer: Transfer, 
    private file: File, 
    private filePath: FilePath, 
    public actionSheetCtrl: ActionSheetController, 
    public platform: Platform, 
    public loadingCtrl: LoadingController,
    private storage: Storage,
    //public jwtHelper: JwtHelperService,
    public global: GlobalProvider
  ) {
      this.login_form = this.formBuilder.group({
        accesscode: [null],//['', Validators.required],
        password: [null],//['', Validators.required],
      });
    }

    ngOnInit() {
      
    }

    showPassword(){
      this.passtype = this.passtype === 'text' ? 'password' : 'text';
      if(this.showPass){
        this.showPass = false;
      }else{
        this.showPass = true;
      }
      
    }

    goRegForm(){
      this.navCtrl.push(VisitorsRegPage);
    }

    goVideoPage(){
      this.navCtrl.push(VideoPage)
    }

    redirectPage(params:string){
      console.log('params = '+params);
      if(params == 'ForgotPage'){
        this.navCtrl.push(ForgotPage);
      }else if(params == 'ReactivatePage'){
        this.navCtrl.push(ReactivatePage);
      }
    }

    loginForm(){
      
      (<HTMLInputElement> document.getElementById('loginBtn')).disabled=true;
      
      /*const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          'Accept': 'application/json'
        })
      };*/
      const httpOptions = new HttpHeaders({
          'Content-Type':  'application/json',
          'Accept': 'application/json'
        })
      console.log(this.accesscode+' '+this.password);
      //alert('hi'+this.accesscode);
      
      
      let postData = JSON.stringify({
          "username": this.accesscode,
          "password": this.password      
      });

      const respObs = ["response","headers"]
      console.log(postData);

      this.http.post(this.global.baseUrl+"login", postData, {headers:httpOptions})//, observe:'response'})//httpOptions)
        .subscribe((data:any) =>  {
          
            if(data.error == true){
              //console.log(data.errorList[0].description);
              let toast = this.toastCtrl.create({
                message: 'Error!.',
                duration: 20000,
                position: 'bottom',
                showCloseButton:true,
                closeButtonText:'Close'
              });

              toast.onDidDismiss(() => {
                console.log('Dismissed toast');
              });
            
              toast.present();
              (<HTMLInputElement> document.getElementById('loginBtn')).disabled=false;
            }else{
              if(data.authenticationDTO.ENABLED == "true"){
                let toast = this.toastCtrl.create({
                  message: 'Logged in successfully',
                  duration: 3000,
                  position: 'bottom',
                  showCloseButton:false,
                  closeButtonText:'Close'
                });
  
                toast.onDidDismiss(() => {
                  console.log('Dismissed toast');
                });
              
                toast.present();

                this.storage.set('accesscode',this.accesscode);
                this.storage.set('Authorization',data.authenticationDTO.Authorization);
                this.storage.set('userrole', data.authenticationDTO.ROLE);

                if(data.authenticationDTO.ROLE == 'ROLE_VISITOR'){
                  this.navCtrl.push(HomePage);
                  setTimeout(function(){
                    (<HTMLInputElement> document.getElementById('loginBtn')).disabled=false;
                  },1000);
                }else if(data.authenticationDTO.ROLE == 'ROLE_SECURITY'){
                  this.navCtrl.push(SecurityhomePage);
                  setTimeout(function(){
                    (<HTMLInputElement> document.getElementById('loginBtn')).disabled=false;
                  },1000);
                }else if(data.authenticationDTO.ROLE == 'ROLE_RECEPTION'){
                  this.navCtrl.push(SecurityhomePage);
                  setTimeout(function(){
                    (<HTMLInputElement> document.getElementById('loginBtn')).disabled=false;
                  },1000);
                }

              }else{
                let toast = this.toastCtrl.create({
                  message: 'Account is Deactivated, Please Reactivate.',
                  duration: 3000,
                  position: 'bottom',
                  showCloseButton:false,
                  closeButtonText:'Close'
                });
                toast.onDidDismiss(() => {
                  console.log('Dismissed toast');
                });
              
                toast.present();

                (<HTMLInputElement> document.getElementById('loginBtn')).disabled=false;
              }
              
            }
          }, error => {
            console.log('******************');
            console.log(error);
            console.log('******************');
          (<HTMLInputElement> document.getElementById('loginBtn')).disabled=false;
          if(error.error.message == 'Unauthorized'){
            let toast = this.toastCtrl.create({
              message: 'Please check Access code/Password',
              duration: 3000,
              position: 'bottom',
              showCloseButton:false,
              closeButtonText:'Close'
            });
            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();
          }else if(error.error.message == 'Bad credentials'){
            let toast = this.toastCtrl.create({
              message: 'Username/Password incorrect!',
              duration: 3000,
              position: 'bottom',
              showCloseButton:false,
              closeButtonText:'Close'
            });
            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();
          }else{
            let toast = this.toastCtrl.create({
              message: error.error.message,
              duration: 3000,
              position: 'bottom',
              showCloseButton:false,
              closeButtonText:'Close'
            });
            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();
          }
          
      });

    }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts